<template>
	<div class="app-container">

		<div class="h1-buttons">
			<h1>Pricing</h1>

			<button class="btn btn-primary" @click="editPricing({})">New pricing</button>
		</div>

		<table class="table loading-container">
			<thead>
				<tr>
					<th scope="col">#</th>
					<th scope="col">Service</th>
					<th scope="col">Target</th>
					<th scope="col">Metric</th>
					<th scope="col">Measure</th>
					<th scope="col">Cents</th>
					<th scope="col">units</th>
					<th scope="col"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(p, index) in pricings.content" :key="index">
					<td>{{ index + 1 }}</td>
					<td>{{ p.service }}</td>
					<td>{{ p.target }}</td>
					<td>{{ p.metric }}</td>
					<td>{{ p.measure }}</td>
					<td>{{ p.cents }}</td>
					<td>{{ p.units }}</td>
					<td class="text-right">
						<div class="btn-group">
							<button title="Edit" class="btn btn-secondary" @click="editPricing(p)">
								<i class="fas fa-pen"></i>
							</button>
							<button title="Delete" class="btn btn-danger" @click="deletePricing(p.id)">
								<i class="fas fa-trash-alt"></i>
							</button>
						</div>
					</td>
				</tr>
			</tbody>
			<tfoot>
				<tr v-if="pricings && pricings.content && !pricings.content.length">
					<td colspan="8" class="nodata">
						<NoData />
					</td>
				</tr>
			</tfoot>
			<Spinner v-if="loading" />
		</table>
		
		<ErrorAlert v-if="errMessage" :error="errMessage" />
		<ErrorDialog ref="errDialog" />
		<PricingEditDialog
			ref="pricingEditDialog"
			v-on:save-success="loadPricings"
		/>
		<div class="pagination-row">
			<p v-if="pricings && pricings.content">
				A total of {{ pricings.totalElements }} price listings. Showing results
				{{ currentSearch.page * currentSearch.size + 1 }} to
				{{
					currentSearch.size == pricings.content.length
						? (currentSearch.page + 1) * currentSearch.size
						: (currentSearch.page + 1) * pricings.content.length
				}}
			</p>
			<Pagination
				v-if="pricings.totalPages > 1"
				:data="pricings"
				v-on:page-selected="selectPage"
			/>
		</div>
	</div>
</template>

<script>
import PricingService from '../../services/pricing';
import Pagination from '../shared/Pagination';
import PricingEditDialog from './PricingEditDialog';
import Spinner from '../shared/Spinner';
import ErrorAlert from '../shared/ErrorAlert';
import ErrorDialog from '../shared/ErrorDialog';
import NoData from '../shared/NoData';

export default {
	name: 'Pricing',
	components: {
		Pagination,
		PricingEditDialog,
		ErrorAlert,
		ErrorDialog,
		Spinner,
		NoData,
	},
	data: function () {
		return {
			pricings: {
				pageable: {
					pageNumber: 0,
					pageSize: 10,
				},
				totalElements: 0,
			},
			currentSearch: {
				page: 0,
				size: 10,
			},
			errMessage: null,
			loading: true,
		};
	},
	created() {
		this.searchPricings();
	},
	methods: {
		searchPricings: function (search = { page: 0, size: 10 }) {
			this.currentSearch = search;
			this.loading = true;
			PricingService.instance()
				.searchPricing(search)
				.then((data) => {
					this.loading = false;
					this.pricings = data.data;
				})
				.catch((error) => {
					this.loading = false;
					this.errMessage = error;
				});
		},
		loadPricings: function () {
			this.searchPricings(this.currentSearch);
		},
		selectPage: function (page) {
			this.searchPricings({ page: page - 1, size: 10 });
		},
		editPricing(pricing) {
			this.$refs.pricingEditDialog.show(pricing);
		},
		deletePricing(id) {
			PricingService.instance()
				.deletePricing(id)
				.then(() => {
					this.searchPricings(this.currentSearch);
				})
				.catch((error) => {
					this.$refs.errDialog.show(error);
				});
		},
	},
};
</script>

<style>
.loading-container {
	position: relative;
}
td.nodata {
	vertical-align: middle;
}
</style>
